export default "__VITE_ASSET__BiEjnr3D__"